export default __webpack_public_path__ + "static/media/show6.153b8182.jpeg";